import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './locales/en.json';
import fi from './locales/fi.json';
import es from './locales/es.json';
import ptBR from './locales/pt-BR.json';
import de from './locales/de.json';
import hi from './locales/hi.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {translation: en},
            fi: {translation: fi},
            es: {translation: es},
            'pt-BR': {translation: ptBR},
            de: {translation: de},
            hi: {translation: hi},
        },
        lng: localStorage.getItem('suttu_lang') || 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // React already escapes
        },
    });

// Persist language choice on change.
i18n.on('languageChanged', (lng) => {
    localStorage.setItem('suttu_lang', lng);
});

export default i18n;
